export default "__VITE_ASSET__09aaa471__"